/**
 * @author Yaochao
 * @date 2021/7/9 20:04
 * @description ？文字提示
 */
import React from "react";
import {Tooltip} from "antd";
import IconQuestion from "../../iconfont/question";

let iconStyle = {
    marginLeft: '5px'
}
const QuestionTip = ({title: title}) => {
    return <Tooltip title={title}>
        <i className='questionTip' style={iconStyle}><IconQuestion/></i>
    </Tooltip>
};

export default QuestionTip;